export enum AppRegionEnum {
  Ru = 'ru',
  Us = 'us',
}
